import 'waypoints/lib/noframework.waypoints.min.js';

class Tabs {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.toggle = self.elem.querySelector('[data-tabs-toggle]');
        self.tabs = self.elem.querySelectorAll('[data-tabs-tab]');
        self.panels = self.elem.querySelectorAll('[data-tabs-panel]');
        self.onOutsideClick = self.onOutsideClick.bind(self);
        self.onEscape = self.onEscape.bind(self);
        self.dropdownIsOpen = false;
    }

    init() {
        let self = this;

        // Dropdown toggle
        self.toggle.addEventListener('click', evt => {
            if(self.dropdownIsOpen) {
                self.closeDropdown();
            } else {
                self.openDropdown();
            }
        });

        // Tabs
        [...self.tabs].map(tab => {
            // Close the dropdown when an item is clicked
            tab.addEventListener('click', evt => {
                evt.preventDefault();

                self.showTab(tab);
                self.closeDropdown();
            });
        });

        // Show the first tab
        self.showTab(self.tabs.item(0));
    }

    showTab(tab) {
        let self = this;

        // Get the related panel
        let panelId = tab.getAttribute('href').substr(1);
        let panel = document.getElementById(panelId);

        // Get all other tabs
        let otherTabs = [...self.tabs].filter(item => item !== tab);

        // Get all other panels
        let otherPanels = [...self.panels].filter(item => item !== panel);

        // Deactivate other tabs
        [...otherTabs].map(item => {
            item.classList.remove('is-active');
            item.setAttribute('aria-selected', false);
        });

        // Activate the tab
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', true);

        // Close other panels
        [...otherPanels].map(item => {
            item.classList.remove('is-active');
        });

        // Update dropdown toggle text
        self.toggle.textContent = tab.textContent;

        // Open the panel
        panel.classList.add('is-active');
    }

    openDropdown() {
        let self = this;

        self.elem.classList.add('is-open');
        self.toggle.setAttribute('aria-expanded', true);

        self.dropdownIsOpen = true;
        
        // Add event listeners
        self.addEventListeners();
    }

    closeDropdown() {
        let self = this;

        self.elem.classList.remove('is-open');
        self.toggle.setAttribute('aria-expanded', false);

        self.dropdownIsOpen = false;
        
        // Remove event listeners
        self.removeEventListeners();
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown
        document.addEventListener('click', self.onOutsideClick);

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown
        document.removeEventListener('click', self.onOutsideClick);

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);
    }

    onOutsideClick(evt) {
        let self = this;

        // If the click was not on the dropdown or its children
        // or the open button or its children
        if (evt.target !== self.elem && !self.elem.contains(evt.target)) {

            // Close the dropdown
            self.closeDropdown();
        }
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.closeDropdown();
        }
    }
}

export default Tabs;
